import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { distinctUntilChanged, map, share, tap } from 'rxjs/operators';
import { UserState } from '../../statemanagement/user.state';
import { isEqual } from 'lodash-es';

@Directive({
    selector: '[showWhenRight]',
    standalone: true
})
export class ShowWhenRightsDirective {
    @Input() set showWhenRight(key: string) {
        this.showOrHide(key);
    }

    constructor(private store: Store<{ user: UserState }>,
                private templateRef: TemplateRef<any>,
                private viewContainer: ViewContainerRef) {
    }

    private showOrHide(key: string) {
        this.store.pipe(
            select('user'),
            map((user: UserState) => user.rights),
            share(),
            distinctUntilChanged((rights1, rights2) => isEqual(rights1, rights2)),
        ).subscribe((rights: string[]) => {
            return rights.indexOf(key) !== -1
                ? this.viewContainer.createEmbeddedView(this.templateRef)
                : this.viewContainer.clear();
        });
    }
}
